import React from "react";

function InputPrompt({ question, fields, stepId, onSubmit }) {
	function handleConfirm() {
		let values = {};
		for (let field of fields) {
			let inputKey = stepId + "_" + field.id;
			let el = document.getElementById("exec-input-" + inputKey);
			if (el) {
				values[inputKey] = field.input_type === "number" ? parseFloat(el.value) || 0 : el.value;
			}
		}
		onSubmit(values);
	}

	return (
		<div className="afs-review__exec-prompt">
			<span className="afs-review__exec-prompt-question">{question}</span>
			<div className="afs-review__exec-prompt-inputs">
				{fields.map(function (field) {
					let inputKey = stepId + "_" + field.id;
					return (
						<div key={field.id} className="afs-review__exec-prompt-input-row">
							<label className="afs-review__exec-prompt-input-label">{field.label}</label>
							<input
								id={"exec-input-" + inputKey}
								type={field.input_type || "text"}
								className="afs-review__exec-prompt-input"
								defaultValue={field.default_value || ""}
								onKeyDown={function (e) {
									if (e.key === "Enter") handleConfirm();
								}}
							/>
						</div>
					);
				})}
				<button className="afs-review__exec-prompt-submit" onClick={handleConfirm}>
					Confirm
				</button>
			</div>
		</div>
	);
}

export default InputPrompt;
